<template>
    <v-container class="container" fluid>
        <v-card>
            <v-form ref="form" v-model="valid" lazy-validation>
                <v-system-bar height="70px" dark color="secondary">
                    <v-spacer></v-spacer>
                    <v-toolbar-title class="white--text"
                        >Customer Form
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-system-bar>

                <v-tabs centered style="padding: 15px 100px 0;">
                    <v-tab>General information</v-tab>
                    <v-tab>Contact information</v-tab>
                    <v-tab>Finance information</v-tab>
                    <v-tab-item class="mx-5">
                        <v-row justify="center">
                            <v-col cols="8">
                                <v-text-field
                                    label="Customer Name *"
                                    v-model="editedItem.Name"
                                    required
                                    :rules="[v => !!v || 'Name is required']"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row justify="center">
                            <v-col cols="8">
                                <v-text-field
                                    label="Address *"
                                    v-model="editedItem.Address"
                                    :rules="[v => !!v || 'Address is required']"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row justify="center">
                            <v-col cols="4">
                                <v-text-field
                                    label="City *"
                                    v-model="editedItem.City"
                                    :rules="[v => !!v || 'City is required']"
                                ></v-text-field>
                            </v-col>

                            <v-col cols="2">
                                <v-text-field
                                    label="Province *"
                                    v-model="editedItem.Province"
                                    :counter="2"
                                    :rules="[
                                        v => !!v || 'Province is required',
                                        v => v.length <= 2
                                    ]"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="2">
                                <v-text-field
                                    label="Postal Code"
                                    v-model="editedItem.PostalCode"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </v-tab-item>
                    <v-tab-item class="mx-5">
                        <v-row justify="center">
                            <v-col cols="4">
                                <v-text-field
                                    label="Phone *"
                                    v-model="editedItem.Telephone"
                                    :rules="[v => !!v || 'Phone is required']"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="4">
                                <v-text-field
                                    label="After hours phone"
                                    v-model="editedItem.OffHoursPhone"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row justify="center">
                            <v-col cols="4">
                                <v-text-field
                                    label="Fax"
                                    v-model="editedItem.Fax"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="4">
                                <v-text-field
                                    label="Website"
                                    v-model="editedItem.WebSite"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="4">
                                <v-text-field
                                    label="Email"
                                    v-model="editedItem.email"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </v-tab-item>
                    <v-tab-item class="mx-5">
                        <v-row justify="center">
                            <v-col cols="4">
                                <v-text-field
                                    label="Split Rate"
                                    prepend-inner-icon="mdi-currency-usd"
                                    v-model="editedItem.SplitCharge"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="2">
                                <v-text-field
                                    label="Demurrage Rate"
                                    prepend-inner-icon="mdi-currency-usd"
                                    v-model="editedItem.DemurrageRate"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="2">
                                <v-text-field
                                    label="Dead Head Rate"
                                    prepend-inner-icon="mdi-currency-usd"
                                    v-model="editedItem.DeadHeadRate"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row justify="center">
                            <v-col cols="2">
                                <v-combobox
                                    v-model="billType"
                                    placeholder="Select Bill Type"
                                    class="mx-3"
                                    label="Bill Type"
                                    :items="billTypes"
                                    dense
                                    hide-details
                                    :item-text="'BillType'"
                                    :item-value="'BillID'"
                                    auto-select-first
                                    @change="selectBillType"
                                ></v-combobox>
                            </v-col>
                            <v-col cols="2">
                                <v-combobox
                                    v-model="company"
                                    placeholder="Select Company"
                                    class="mx-3"
                                    label="Company"
                                    :items="companies"
                                    dense
                                    hide-details
                                    :item-text="'CompanyName'"
                                    :item-value="'CompanyID'"
                                    @change="selectCompany"
                                ></v-combobox>
                            </v-col>
                            <v-col cols="2">
                                <v-combobox
                                    v-model="group"
                                    class="mx-3"
                                    label="Select Group Invoice"
                                    :items="groupCustomers"
                                    dense
                                    hide-details
                                    item-text="GroupName"
                                    item-value="InvGroupID"
                                    auto-select-first
                                    @change="selectGroupInvoice"
                                ></v-combobox>
                            </v-col>
                        </v-row>
                    </v-tab-item>
                </v-tabs>
                <v-row justify="end">
                    <v-col cols="12">
                        <v-btn
                            exact
                            dark
                            color="secondary"
                            class="mr-10 white--text"
                            :to="'/catalogs/customers'"
                            style="float:right;"
                        >
                            Close
                            <v-icon right dark>mdi-close</v-icon>
                        </v-btn>
                        <v-btn
                            dark
                            color="secondary"
                            class="mx-2  white--text"
                            @click="validate()"
                            style="float:right;"
                        >
                            Save
                            <v-icon right dark>mdi-content-save</v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
            </v-form>
        </v-card>
    </v-container>
</template>

<script>
import axios from 'axios';
export default {
    name: 'CustomersForm',
    data() {
        return {
            customerID: 0,
            billType: [],
            billTypes: [],
            companies: [],
            company: [],
            defaultItem: {
                Name: null,
                Telephone: null,
                OffHoursPhone: null,
                Fax: null,
                WebSite: null,
                email: null,
                Address: null,
                City: null,
                Province: null,
                PostalCode: null,
                SplitCharge: null,
                DemurrageRate: null,
                DeadHeadRate: null
            },
            editedItem: {
                Name: null,
                Telephone: null,
                OffHoursPhone: null,
                Fax: null,
                WebSite: null,
                email: null,
                Address: null,
                City: null,
                Province: null,
                PostalCode: null,
                SplitCharge: null,
                DemurrageRate: null,
                DeadHeadRate: null,
                Active: null,
                BillType: [],
                InvoiceGroup: null
            },
            group: [],
            groupCustomers: [],
            valid: true
        };
    },
    mounted() {
        this.groupCustomer();
        this.getCompanies();
        this.getBillType();
    },
    methods: {
        loadCustomerData: function() {
            this.$store.state.isLoading = true;
            this.customerID = this.$store.state.editedCustomer.id;
            if (this.customerID != 0) {
                axios
                    .get('customer/' + this.customerID, {
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token
                        }
                    })
                    .then(async response => {
                        console.log('Loading customers...');
                        this.editedItem = await Object.assign(
                            {},
                            response.data
                        );

                        const idx = this.billTypes.findIndex(x => {
                            return x.BillID == response.data.BillType;
                        });

                        const idxInv = this.groupCustomers.findIndex(x => {
                            return x.InvGroupID == this.editedItem.InvoiceGroup;
                        });

                        const idxComp = this.companies.findIndex(x => {
                            return x.CompanyID == response.data.CompanyID;
                        });

                        this.group = this.groupCustomers[idxInv];
                        this.billType = this.billTypes[idx];
                        this.company = this.companies[idxComp];
                        this.$store.state.editedCustomer.id = 0;
                    })
                    .catch(function(error) {
                        console.log(error);
                    });
            }
            this.$store.state.isLoading = false;
        },

        getBillType: function() {
            this.$store.state.isLoading = true;
            axios
                .get('bill-type')
                .then(response => {
                    this.billTypes = response.data;
                    this.loadCustomerData();
                })
                .catch(function(error) {
                    console.log(error);
                });
            this.$store.state.isLoading = false;
        },
        getCompanies: function() {
            this.$store.state.isLoading = true;
            axios
                .get('company')
                .then(response => {
                    this.companies = response.data;
                })
                .catch(function(error) {
                    console.log(error);
                });
            this.$store.state.isLoading = false;
        },
        groupCustomer: function() {
            this.$store.state.isLoading = true;
            axios
                .get('invoice-group-customer')
                .then(response => {
                    this.groupCustomers = response.data;
                    console.log(this.groupCustomers);
                })
                .catch(function(error) {
                    console.log(error);
                });
            this.$store.state.isLoading = false;
        },
        selectBillType: function() {
            this.editedItem.BillType = this.billType.BillID;
        },
        selectCompany: function() {
            this.editedItem.CompanyID = this.company.CompanyID;
        },
        selectGroupInvoice: function() {
            console.log(this.group);
            if (this.group === null) {
                this.editedItem.InvoiceGroup = null;
            } else {
                this.editedItem.InvoiceGroup = this.group.InvGroupID;
            }
        },
        validate() {
            if (this.$refs.form.validate() == false) {
                this.$refs.form.validate();
            } else {
                this.save();
            }
        },
        newCustomer: function() {
            this.$store.state.isLoading = true;
            var str = this.$store;
            this.editedItem.Active = 1;
            console.log(this.editedItem);
            axios
                .post('customer', this.editedItem)
                // eslint-disable-next-line no-unused-vars
                .then(response => {
                    this.$store.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'New customer added.'
                    });
                    this.editedItem = Object.assign({}, this.defaultItem);
                    this.$router.push('/catalogs/customers');
                })
                .catch(error => {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
            this.$store.state.isLoading = false;
        },
        editCustomer: function() {
            var str = this.$store;
            this.$store.state.isLoading = true;
            axios
                .put('customer/' + this.customerID, this.editedItem)
                // eslint-disable-next-line no-unused-vars
                .then(response => {
                    this.$store.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'Customer information saved.'
                    });
                    this.editedItem = Object.assign({}, this.defaultItem);
                    this.$router.push('/catalogs/customers');
                })
                .catch(error => {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });

            this.$store.state.isLoading = false;
        },
        save: function() {
            if (this.customerID > 1) {
                this.editCustomer();
            } else {
                this.newCustomer();
            }
        }
    }
};
</script>
